<template>
    <item :icon="icon" name="导出" @click="onClick"/>
</template>

<script>
import icon from '../icons/export.svg'
import Item from './item'
export default {
    components: {
        Item
    },
    props: {
        // 标准参数
        api: {
            type: String,
            default: ''
        },
        query: {
            type: Object
        },
        columns: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data () {
        return {
            icon,
            command: 'export',
            loading: false
        }
    },
    methods: {
        onClick () {
            this.loading = true
            this.$nextTick(() => {
                const columns = this.columns.filter(item => item.prop)
                this.$api(this.api, {
                    query: this.query,
                    columns: columns.map(item => item.prop)
                }).then(url => {
                    if (typeof window !== undefined) {
                        const documnet = window.document
                        const a = document.createElement('a')
                        a.href = url
                        document.body.appendChild(a)
                        a.click()
                        this.loading = false
                    }
                }).catch(e => {
                    console.error(e)
                })
            })
        }
    }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>



// WEBPACK FOOTER //
// src/components/framework/data-grid/toolbar/export.vue